<div>
  <div class="modal-header">
    <h3>Follow steps to proceed</h3>
  </div>
  <div class="modal-body" style="padding-right: 0">
    <ng-container *ngIf="error">
      <p class="has-error">{{ error }}</p>
    </ng-container>
    <div class="col-md-12 text-center" style="padding-bottom: 10px; padding-right:15px; display: flex;">
      <input placeholder="Email address connected to your application" class="form-control" type="email"
             name="email" id="email"
             [(ngModel)]="email"
             (keyup.enter)="requestKey()" style="flex: 1;"/>
    </div>
    <div *ngIf="email_submitted" class="col-md-12 text-center"
         style="padding-bottom: 10px; padding-right:15px; display: flex;">
      <input placeholder="Check your email for the access key" class="form-control" type="password"
             [(ngModel)]="access_key"/>
    </div>
    <div *ngIf="email_submitted" class="col-md-12 text-center"
         style="padding-bottom: 10px; padding-right:15px; display: flex;">
<!--      todo: make placeholder dynamic based on applicationService-->
      <input [placeholder]="idFieldLabel" class="form-control" type="text" [(ngModel)]="permit_id"
      />
    </div>
    <!--    <div *ngIf="email_submitted" class="col-md-12 text-center"-->
    <!--         style="padding-bottom: 10px; padding-right:0; display: flex;">-->
    <!--      <input placeholder="Reporting Year" class="form-control" type="text" [(ngModel)]="reporting_year"/>-->
    <!--    </div>-->
    <div *ngIf="email_submitted" style="margin-right: 15px;">
      <app-dynamic-input *ngFor="let f of additionalFields" [(item)]="additionalFieldValues" [key]="f"
                         [meta]="additionalFieldsMeta"
                         [usePlaceHolderLabel]="true"></app-dynamic-input>
    </div>
  </div>


  <div class="modal-footer">
    <button class="btn btn-default" *ngIf="!submitting" (click)="cancel()">Cancel</button>
    <button *ngIf="email_submitted && !submitting" class="btn btn-primary" (click)="start()">Submit</button>
    <button *ngIf="!email_submitted && !submitting" class="btn btn-primary" [disabled]="!email" (click)="requestKey()">
      Request Key
    </button>
    <button *ngIf="submitting" class="btn btn-primary" disabled>
      <i class="fa fa-spinner fa-pulse"></i>
    </button>
  </div>
</div>
